module.exports = __webpack_public_path__ + "img/pragmaticplay.f311a374.svg";